import { jsxs, jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import MinusCircle from "../../assets/icons/minus-circle.js";
import PlusCircle from "../../assets/icons/plus-circle.js";
import { ButtonContainer, CountButton, Count } from "./menu-item-counter.styles.js";
import "@mui/material";
const MenuItemCounter = ({ value, disabled = false, max = 100, step = 1, onChange }) => {
  const handleChange = useCallback(
    (isPlus) => (event) => {
      event.stopPropagation();
      onChange == null ? void 0 : onChange(isPlus ? value + step : value - step);
    },
    [value]
  );
  return /* @__PURE__ */ jsxs(ButtonContainer, { children: [
    /* @__PURE__ */ jsx(
      CountButton,
      {
        disabled: disabled || value <= 0,
        disableRipple: true,
        disableTouchRipple: true,
        disableFocusRipple: true,
        onClick: handleChange(),
        children: /* @__PURE__ */ jsx(MinusCircle, {})
      }
    ),
    /* @__PURE__ */ jsx(Count, { children: value }),
    /* @__PURE__ */ jsx(
      CountButton,
      {
        disabled: disabled || max !== void 0 && value >= max,
        disableRipple: true,
        disableTouchRipple: true,
        disableFocusRipple: true,
        onClick: handleChange(true),
        children: /* @__PURE__ */ jsx(PlusCircle, {})
      }
    )
  ] });
};
export {
  MenuItemCounter
};
